export default __webpack_public_path__ + "static/media/outlineButterfly.2fa24599.svg";